// ios终端
const isiOS = () => {
    const u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};
//android终端
const isAndroid = () => {
    // eslint-disable-next-line
    const ua = navigator.userAgent.toLowerCase();
    const obj = ua.indexOf('android') != -1 || ua.indexOf('linux') > -1;
    if (obj) {
        return true;
    } else {
        return false;
    }
};
// 是否微信
const isWX = () => {
    const u = navigator.userAgent;
    return u.indexOf('MicroMessenger') > -1;
};

const terminal = () => {
    const u = navigator || {};
    return {
        appMinorVersion: u.appMinorVersion,
        appName: u.appName,
        appVersion: u.appVersion,
        userAgent: u.userAgent
    };
};
export { isiOS, isAndroid, isWX, terminal };



// WEBPACK FOOTER //
// ./src/util/browser.js